/**
 * Gift with Purchase Script
 * Automatically adds a free gift product to cart when order meets specified conditions
 */
import { utils } from '@hh/global.js';
const { reRenderShopifySections } = utils;

document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const config = window.gwpConfig || {};

  // Check cart and add gift if conditions are met
  function checkAndAddGift() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Check if gift is already in cart
        const giftInCart = cart.items.find(
          item => item.variant_id.toString() === config.giftProductId && 
          item.properties._gift === 'true'
        );

        if (cartEligible(cart) && !giftInCart) {
          addGiftToCart();
        } 

        if (!cartEligible(cart) && giftInCart) {
          removeGiftFromCart(cart);
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // Determine if we should add the gift based on cart contents
  function cartEligible(cart) {
    // Check if cart has other items besides the gift
    const nonGiftItems = cart.items.filter(item => item.variant_id.toString() !== config.giftProductId);
    if (nonGiftItems.length === 0) {
      return false;
    }
    
    // Calculate eligible cart total (excluding gift product)
    const eligibleTotal = calculateEligibleTotal(cart);
    
    // Check if total meets threshold
    if (eligibleTotal < config.minCartTotal) {
      return false;
    }
    
    return true;
  }

  // Calculate cart total excluding specified products
  function calculateEligibleTotal(cart) {
    let total = cart.items.reduce((sum, item) => {
      // Skip excluded products
      if (config.excludedProductIds && config.excludedProductIds.includes(item.product_id.toString())) {
        return sum;
      }
      // Skip the gift product itself
      if (item.variant_id.toString() === config.giftProductId) {
        return sum;
      }

      return sum + item.line_price;
    }, 0);
    
    return total;
  }

  // Add gift product to cart
  function addGiftToCart() {
    const data = {
      id: config.giftProductId,
      quantity: 1,
      properties: {
        '_gift': 'true'
      },
      sections: 'mini-cart,header'
    };
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(item => {
      // Rerender cart sections
      if (item.sections) {
        reRenderShopifySections(item);
      } else {
        // Fallback if sections aren't returned
        fetch('/?sections=mini-cart,header')
          .then(response => response.json())
          .then(sections => {
            reRenderShopifySections(sections);
          })
          .catch(error => console.error('Error fetching sections:', error));
      }
    })
    .catch(error => console.error('Error adding gift to cart:', error));
  }
  
  // Remove gift product from cart if it exists
  function removeGiftFromCart(cart) {
    const giftItem = cart.items.find(item => item.variant_id.toString() === config.giftProductId);
    
    // If gift is in cart, remove it
    if (giftItem) {
      const data = {
        updates: {
          [giftItem.key]: 0
        },
        sections: 'mini-cart,header'
      };
      
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(cart => {
        // Rerender cart sections
        if (cart.sections) {
          reRenderShopifySections(cart);
        } else {
          // Fallback if sections aren't returned
          fetch('/?sections=mini-cart,header')
            .then(response => response.json())
            .then(sections => {
              reRenderShopifySections(sections);
            })
            .catch(error => console.error('Error fetching sections:', error));
        }
      })
      .catch(error => console.error('Error removing gift from cart:', error));
    }
  }
  
  // Check on page load
  checkAndAddGift();
  
  // Listen for AJAX cart adds
  const originalFetch = window.fetch;
  window.fetch = function() {
    const result = originalFetch.apply(this, arguments);
    
    // If this is a cart add/update/change request
    if (arguments[0].includes('/cart/add') || 
        arguments[0].includes('/cart/update') || 
        arguments[0].includes('/cart/change')) {
      result.then(() => setTimeout(checkAndAddGift, 500));
    }
    
    return result;
  };
});
